export { default as SystemSettingConfig } from './SystemSettingConfig';
